export enum LoanStatus {
	'ACTIVE' = 'active',
	'CLOSED' = 'closed',
	'PAID' = 'paid',
	'HOLD' = 'hold',
}
